import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule, JsonpModule } from '@angular/http';
import {
  RouterModule,
  Routes
} from '@angular/router';
import 'hammerjs';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {
  LocationStrategy,
  HashLocationStrategy,
  APP_BASE_HREF
} from '@angular/common';

// Material-Componenten ----------------------------------------------------*/
import { SwsMaterialModule } from './material/material.module';
import { DataSource } from '@angular/cdk';


// Componenten ------------------------------------------------------------*/
import { AppComponent } from './app.component';
import { InfopageComponent } from './infopage/infopage.component';
import { InfoheaderComponent } from './infoheader/infoheader.component';
import { InfofooterComponent } from './infofooter/infofooter.component';
import { ArtikelsucheComponent } from './artikelsuche/artikelsuche.component';
import { ArtikellisteComponent } from './artikelliste/artikelliste.component';
import { ArtikelzeileComponent } from './artikelzeile/artikelzeile.component';
import { ArtikeldetailsComponent } from './artikeldetails/artikeldetails.component';
import { ArtikeltabelleComponent } from './artikeltabelle/artikeltabelle.component';
import { InfohomeComponent } from './infohome/infohome.component';
import { LoginpageComponent } from './loginpage/loginpage.component';
import { AboutComponent } from './about/about.component';
import { LagerplatzzeileComponent } from './lagerplatzzeile/lagerplatzzeile.component';

// Services ------------------------------------------------------------*/
import { AUTH_PROVIDERS } from './services/auth.service';
import { LoggedInGuard } from './logged-in.guard';
import { UserService } from './services/user.service';
import { ArtikelService } from './services/artikel.service';
import { SettingsService } from './services/settings.service';
import { LagerplatzService } from './services/lagerplatz.service';
import { LagerplatzlisteComponent } from './lagerplatzliste/lagerplatzliste.component';
import { LagerartikelzeileComponent } from './lagerartikelzeile/lagerartikelzeile.component';

// Routen ------------------------------------------------------------*/
const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: InfohomeComponent },
  { path: 'login', component: LoginpageComponent },
  { path: 'infopage', component: InfopageComponent, canActivate: [ LoggedInGuard ] },
  { path: 'details/:artnr', component: ArtikeldetailsComponent, canActivate: [ LoggedInGuard ] },
  { path: 'about', component: AboutComponent }
];



@NgModule({
  declarations: [
    AppComponent,
    InfopageComponent,
    InfoheaderComponent,
    InfofooterComponent,
    ArtikelsucheComponent,
    ArtikellisteComponent,
    ArtikeltabelleComponent,
    ArtikelzeileComponent,
    ArtikeldetailsComponent,
    InfohomeComponent,
    LoginpageComponent,
    AboutComponent,
    LagerplatzzeileComponent,
    LagerplatzlisteComponent,
    LagerartikelzeileComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    JsonpModule,
    RouterModule.forRoot(routes), // <-- routes
    SwsMaterialModule
  ],
  providers: [
      UserService,
      ArtikelService,
      LagerplatzService,
      SettingsService,
      AUTH_PROVIDERS,
      LoggedInGuard,
     {provide: APP_BASE_HREF, useValue: '/'}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/Crossplatform/swsLagerinfo/src/app/app.module.ts